import { useReadContract } from "wagmi";

const useTokenId = (address, abi, provider) => {

  return useReadContract({
    address: address,
    abi: abi,
    functionName: "getTotalMinted",
    provider: provider,
  });
};

export default useTokenId;
